var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conatiner-product-page"},[_c('div',[_c('grid-product'),_c('modal-regalo')],1),(!_vm.productDetail)?_c('div',[_c('skeleton-product-desktop'),_c('skeleton-product-movil')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }